export const scrollToId = (id: string) => {
  setTimeout(() => {
    const elem = document.getElementById(id);
    elem?.scrollIntoView({
      behavior: 'smooth',
    });
  }, 0);
};
